export default __webpack_public_path__ + "static/media/html5-plain.69274ea2.svg";